import CustomError from './custom-error';
export default CustomError.withMessageCreator('UnimplementedError', function (args) {
    return args ? "called with arguments: " + JSON.stringify(args) : 'called with nothing';
});
//# sourceMappingURL=unimplemented-error.js.map